module.exports = __webpack_public_path__ + "static/img/top03.e5f30d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/top03.png
// module id = K5jJ
// module chunks = 1